module.exports = __webpack_public_path__ + "d308073b/img/saly-icon.39e12342.jpg";